import 'babel-polyfill';
import 'whatwg-fetch';
import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';
import reducer from './reducers.js';
import RakutenAuth from './containers/RakutenAuth.jsx';
import Dashboard from './components/Dashboard.jsx';
import Index from './components/Index.jsx';
import { initi18n, fetchStrategyForAdvertisable} from './actions.js';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import moment from 'moment';


let today = moment.utc().startOf('day');

let store = applyMiddleware(thunkMiddleware)(createStore)(reducer, {
    shopId: null,
    externalShopId: null,
    shopName: null,
    username: null,
    merchantDashAllowed: false,
    isReadOnlyUser: false,
    i18nLoaded: false,
    advertisableEid: null,
    finishedLoadingStrategy: false,
    strategy: null,
    aggregatePerformance: null,
    monthToDatePerformance: null,
    runMonthlyBudgetCapValidation: false,
    dailyPerformance: null,
    reportingStartDate: null,
    recommendedBudget: null,
    isRecommendedBudgetDisplayed: false,
    reportingEndDate: today,
    reportingSort: {
        direction: '',
        accessor: null,
        key: ''
    }
});


// fetch some must-have data during initialization
store.dispatch(initi18n());
store.dispatch(fetchStrategyForAdvertisable());

function logPageView() {
    ga('set', 'page', window.location.pathname);
    ga('send', 'pageview');
}

render((
    <Provider store={ store }>
        <Router history={ browserHistory } onUpdate={ logPageView }>
            <Route path={ `${process.env.ROOT_PATH}` } component={ RakutenAuth }>
                <IndexRoute component={ Index } />
                <Route path='campaign' component={ Dashboard } />
                <Route path='dashboard' component={ Dashboard } />
            </Route>
        </Router>
    </Provider>),
    document.getElementById('app'));
